module.exports = __webpack_public_path__ + "img/gd1.f7208fc6.gif";